'use client'

import { useEffect, useRef } from 'react'
import { useUser } from '@/contexts/user'
import { useChangelogStore } from '@/stores/changelogStore'
import { useLocale } from 'next-intl'

const STORAGE_KEY = 'changelogReadStatus'

export const ChangelogSyncHandler = () => {
  const { user } = useUser()
  const fetchChangelogs = useChangelogStore((state) => state.fetchChangelogs)
  const previousUserId = useRef(user?._id)
  const locale = useLocale()

  useEffect(() => {
    const hasJustLoggedIn = !previousUserId.current && user?._id

    if (hasJustLoggedIn) {
      try {
        const storedReadIds = JSON.parse(
          localStorage.getItem(STORAGE_KEY) || '[]',
        ) as string[]

        if (storedReadIds.length > 0) {
          // Sync local read IDs to the server in the background
          fetch('/api/inbox/mark-as-read', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ changelogIds: storedReadIds }),
          }).catch((error) => {
            console.error('Failed to sync local read status to server:', error)
          })
        }

        // Immediately refetch data to get the merged (local + server) read status
        fetchChangelogs(locale, user)
      } catch (error) {
        console.error('Error during changelog sync on login:', error)
      }
    }

    previousUserId.current = user?._id
  }, [user, locale, fetchChangelogs])

  return null // This component renders nothing
}
